/**=========================================================
 * Module: grouper.js
 * Grouper Controller
 =========================================================*/

App.controller('GrouperController',
    ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'ngDialog', 'LocalRestangular', '$sce', '$interval',
        function ($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, ngDialog, LR, $sce, $interval) {
            "use strict";

            $scope.elements = {}
            $scope.selectedElements = []

            var loadElementsFunctions = {
                'readFromCsv': function () {
                    var files = $scope.model[$scope.field.elements.watch]
                    for (var i = 0; i < files.length; i++) {
                        LR.one('fs', CONFIG.folderRoot + files[i].filename).get()
                            .then(function (result) {
                                var list = result.fileContent.match(/Statistics for file\(s\) ([^<]+)/)[1].split(', ')
                                for (var j = 0; j < list.length; j++) {
                                    var id = list[j].normalize().replace(/ /, '_')
                                    $scope.elements[id] = {
                                        id: id,
                                        label: list[j],
                                        lcLabel: list[j].toLowerCase(),
                                        visible: true,
                                        selected: false,
                                        added: false
                                    }
                                    $scope.filterElements()
                                }
                                $scope.updateCounters()
                            }).catch(console.error)
                    }
                }
            }

            $scope.select = function(e){
                e.selected = !e.selected
                if(e.selected) { $scope.selectedElements.push(e.id) }
                else { $scope.selectedElements.splice($scope.selectedElements.indexOf(e.id), 1)}
                $scope.updateCounters({toggleSelected: e.selected})
            }
            $scope.selectAll = function(e){
                var c = 0;
                $scope.selectedElements = []
                for(var k in $scope.elements){
                    var e = $scope.elements[k]
                    if(e.visible && !e.added) {
                        e.selected = true
                        $scope.selectedElements.push(e.id)
                        c++
                    }
                }
                $scope.updateCounters({selectAll: c})
            }
            $scope.unselectAll = function(e){
                $scope.selectedElements = []
                for(var k in $scope.elements){
                    var e = $scope.elements[k]
                    e.selected = false
                }
                $scope.updateCounters({selectAll: 0})
            }

            $scope.updateModel = function(){
                $timeout(function(){$scope.form.model[$scope.field.name] = {
                    elements: $scope.elements,
                    groups: $scope.groups
                }}, 10)
            }


            $scope.updateCounters = function(options){
                if(!options){
                    $scope.counters = {
                        total: 0,
                        visible: 0,
                        selected: 0,
                        added: 0,
                        groups: 0
                    }
                    for(var k in $scope.elements){
                        $scope.counters.total++
                        $scope.counters.visible += $scope.elements[k].visible && !$scope.elements[k].added ? 1 : 0
                        $scope.counters.selected += $scope.elements[k].selected ? 1 : 0
                        $scope.counters.added += $scope.elements[k].added ? 1 : 0
                    }
                    for(var k in $scope.groups){
                        $scope.counters.groups++
                    }
                } else {
                    if(options.toggleSelected!==null && options.toggleSelected!==undefined){
                        $scope.counters.selected += options.toggleSelected ? 1 : -1
                    }
                    if(options.selectAll!==null && options.selectAll!==undefined){
                        $scope.counters.selected = options.selectAll
                    }
                    if(options.add){
                        $scope.counters.added++
                        $scope.counters.visible--
                    }
                    if(options.remove){
                        $scope.counters.added--
                        $scope.counters.visible++
                    }
                    if(options.addGroup){
                        $scope.counters.groups += options.addGroup
                    }
                }
            }
            $scope.updateCounters()

            $scope.groups = {}
            $scope.updateGroups = function(field){
                var removedGroups = []
                for(var k in $scope.groups){
                    if($scope.model[field].indexOf(k)<0){
                        removedGroups.push(k)
                        if($scope.groups[k].elements.length){
                            for(var j=$scope.groups[k].elements.length-1; j>=0; j--){
                                $scope.removeElement($scope.groups[k].elements[j], $scope.groups[k])
                            }
                        }
                    }
                }
                for(var i in removedGroups){
                    delete $scope.groups[removedGroups[i]]
                    $scope.updateCounters({addGroup:-1})
                }
                for(var j in $scope.model[field]){
                    if(!$scope.groups[$scope.model[field][j]]){
                        $scope.groups[$scope.model[field][j]] = {
                            elements: [],
                            name: $scope.model[field][j]
                        }
                        $scope.updateCounters({addGroup:1})
                    }
                }
            }

            $scope.filterValue = ''

            $scope.filterElements = function () {
                
                if(this.filterV!==undefined){
                    $scope.filterValue = this.filterV.toLowerCase()
                }
                for (var k in $scope.elements) {
                    var el = $scope.elements[k]
                    if ($scope.filterValue && el.lcLabel.indexOf($scope.filterValue) < 0) {
                        el.visible = false
                        el.selected = false
                        $scope.selectedElements.splice($scope.selectedElements.indexOf(el.id), 1)
                    } else {
                        if(!el.added){
                            el.visible = true
                        }
                    }
                }
                $scope.updateCounters()
                
            }


            var addElement = function(el, group){
                $scope.elements[el].added = true
                if($scope.elements[el].selected){
                    $scope.updateCounters({toggleSelected: false})
                }
                $scope.elements[el].selected = false
                $scope.filterElements()
                $scope.selectedElements.splice($scope.selectedElements.indexOf(el), 1)
                $scope.groups[group].elements.push($scope.elements[el])
                $scope.updateCounters({add: true})
                $scope.updateModel()
            }

            $scope.removeElement = function(el, group){
                $scope.elements[el.id].added = false
                var index = -1
                for(var i=0; i<$scope.groups[group.name].elements.length; i++){
                    if($scope.groups[group.name].elements[i].id==el.id){
                        index = i
                    }
                }
                $scope.filterElements()
                $scope.groups[group.name].elements.splice(index, 1)
                $scope.updateCounters({remove: true})
                $scope.updateModel()
            }

            $scope.dropped = function(el, group, data){
                addElement(el, group)
                var others = data.data
                for(var i=0; i<others.length; i++){
                    if(others[i]!=el){
                        addElement(others[i], group)
                    }
                }
                $scope.filterElements()
            }

            if ($scope.field.elements && $scope.field.elements.watch) {
                $scope.$watch('model.' + $scope.field.elements.watch + '.length', function () {
                    loadElementsFunctions[$scope.field.elements.fn]()
                })
            }
            if ($scope.field.groups && $scope.field.groups.watch) {
                $scope.updateGroups($scope.field.groups.watch)
                $scope.$watch('model.' + $scope.field.groups.watch + '.length', function () {
                    $scope.updateGroups($scope.field.groups.watch)
                })
            }
        }
    ]);